import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";
import ModuleQuestion from "../../components/ModuleQuestion";

const Module_1_0 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}

      <main className="col-sm-8 module-content">
        <section>
          <h1 className="blue text-uppercase b mt-5 mb-4">3.0.9 Case 9</h1>
          <p className="me-4">Estimated time to complete: 3-5 minutes</p>
        </section>
        <ModuleQuestion
          correctAnswer="B"
          assessmentName="self_assessment_109"
          videoTranscript={
            <>
              <p>
                <strong>AUDIO</strong>
                <br />
                VO: (FEMALE)
                <br />
                This is self-assessment case number 109. This is a negative
                case. Beginning at the level of the temporal lobes, intense
                activity is seen in finger-like projections within the left
                temporal region. This activity can be demonstrated to be within
                the white matter. On the right-hand side, distinct white matter
                tracts are not readily identifiable at this level. It is
                important to review multiple slices, however, and immediately
                superior, white matter tracts are delineated on the right as
                well as on the left. Less intense activity is seen in the
                surrounding gray matter. There is no loss of gray-white contrast
                in the temporal or occipital regions bilaterally. Entering into
                the frontal cortices, intense uptake is also seen in the white
                matter in the right and left frontal cortex. This is surrounded
                by less intense activity in the surrounding gray matter. Again,
                there is no loss of gray-white contrast here. In addition, white
                matter tracts are delineated, coursing from the front of the
                brain to the back of the brain on the left as well as on the
                right. In the posterior parietal region, identified here,
                increased activity is not seen within the gray matter, and there
                is preserved gray-white contrast. Near the superior parietal
                region, once again, white matter tracts are delineated on the
                left as well as on the right and, in the medial parietal region,
                increased activity is not seen within the gray matter.
              </p>
              <p>
                You may see focal uptake within the white matter, and it is
                important to remember that white matter distribution may be
                patchy. In order to localize and to further characterize this
                focal uptake, you can utilize the sagittal and coronal views to
                ensure that this uptake is within the white matter and not in
                the adjacent gray matter. If there still remains concern,
                utilizing the accompanying fused images may also be beneficial.
                In this case, on the CT images, this focal uptake can be seen to
                be within the white matter and is not within the adjacent gray
                matter. As there is no loss of gray-white contrast in any
                region, this case is negative.
              </p>
            </>
          }
          previousLesson="/module-3/module-3-0-8"
          nextLesson="/module-3/module-3-0-10"
          iframeURL="https://cdnapisec.kaltura.com/p/1759891/sp/175989100/embedIframeJs/uiconf_id/24639831/partner_id/1759891?iframeembed=true&playerId=kaltura_player_1079861249&entry_id=1_rvzf3mq8&wid=_1759891&flashvars[sideBarContainer.plugin]=true&flashvars[sideBarContainer.position]=left&flashvars[sideBarContainer.clickToClose]=true&flashvars[chapters.plugin]=true&flashvars[chapters.layout]=vertical&flashvars[chapters.thumbnailRotator]=false&flashvars[streamSelector.plugin]=true&flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&flashvars[dualScreen.plugin]=true"
          questionType="assessment"
          videoId="1_rvzf3mq8"
        />
      </main>
    </div>
  );
};

export default Module_1_0;
